import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import Page from 'src/shared-components/Page/Page';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { BreadCrumbs } from 'src/shared-components/design-system/BreadCrumbs';
import ViewedDrugsContainer from '../../shared-components/ViewedDrugs/ViewedDrugsContainer';

import trns from './trns';
import { Article, ArticlePreview } from '../../api/types';
import ArticleContent from './ArticleContent';
import DoctorCardContainer from '../home/components/DoctorCardContainer/DoctorCardContainer';

const images = {
  'uvaga-covid': 'covid.jpg',
  dopomogo: 'help.jpg',
  'shkira-yak-indykator-zakhvoryuvan': 'skin.jpg',
  'moya-aptechka': 'myFirstAidKit.jpg'
};

interface Props {
  articleData: Article;
  articlePreviewData: ArticlePreview[];
}

const ArticlePageContainer: FC<Props> = ({ articleData }) => {
  return (
    <Page>
      <BreadCrumbs
        items={[
          {
            id: 'home',
            title: <FormattedMessage {...trns.homeBreadCrumb} />,
            href: '/'
          },
          {
            id: 'article',
            title: <FormattedMessage {...trns.tips} />,
            href: '/blog'
          }
        ]}
      />
      <Constraints className="pb-12 px-5 l:px-0">
        <h1 className="fs-header6-bold text-astronautBlue pb-10 pt-7">
          {articleData?.title}
        </h1>
        <div className="border-b border-silver pb-3 w-full">
          <div className=" max-w-[1060px]">
            <ArticleContent
              images={images}
              content={articleData?.content}
              translitName={articleData?.translitName}
            />
          </div>
        </div>
        {articleData?.doctorReviewer ? (
          <DoctorCardContainer doctorReviewer={articleData.doctorReviewer} />
        ) : null}
        <ViewedDrugsContainer />
      </Constraints>
    </Page>
  );
};

export default ArticlePageContainer;
